// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-student-response--studentResponse--2a3dZAPK {\n  flex: 1;\n  min-height: 0;\n}\n.overlay-student-response--studentResponse--2a3dZAPK .overlay-student-response--responseArea--AmiNWpkR {\n  height: calc(100% - 80px);\n  padding: 15px 20px 15px 20px;\n  overflow-y: auto;\n  background-color: #fff9f3;\n}\n.overlay-student-response--studentResponse--2a3dZAPK .overlay-student-response--responseArea--AmiNWpkR .overlay-student-response--selectMessage--3vP8yedR {\n  font-style: italic;\n  text-align: center;\n}\n", ""]);
// Exports
exports.locals = {
	"studentResponse": "overlay-student-response--studentResponse--2a3dZAPK",
	"responseArea": "overlay-student-response--responseArea--AmiNWpkR",
	"selectMessage": "overlay-student-response--selectMessage--3vP8yedR"
};
module.exports = exports;
